(function() { module.exports = window["Next"]["Button"]; }());